import React, { Component } from 'react'
import { Fragment } from 'react'
import { Navbar, Container, Row, Col, Button, Card, Modal, ListGroup, ListGroupItem } from 'react-bootstrap';
import { Navigate } from 'react-router';
import { Link } from 'react-router-dom';
import { Form } from 'react-bootstrap'
import DefaultImage from '../../assets/images/no_image.jpg'; // Static Default Image
import axios from 'axios'
import AppURL from '../../api/AppURL';
class Profile extends Component {



     
     constructor() {
          super();
          this.state = {
               uploadedImage: '', // Initially empty
               previewImage: '', // Preview before upload
          };
     }



     componentDidMount() {
          axios.get(AppURL.GetUserProfile, {
               headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
               },
          })
               .then((response) => {
                    // If no profile photo, set default image
                    const profilePhoto = response.data.profile_photo || DefaultImage;
                    this.setState({ uploadedImage: profilePhoto });
               })
               .catch((error) => {
                    console.error('Failed to fetch profile photo:', error);
                    this.setState({ uploadedImage: DefaultImage });
               });
     }




     // Handle image selection
     handleImageUpload = (event) => {
          const file = event.target.files[0];
          if (file) {
               const reader = new FileReader();
               reader.onload = (e) => {
                    this.setState({ previewImage: e.target.result });
               };
               reader.readAsDataURL(file);
          }
     };

     // Submit Form to Upload Image
     formSubmit = (e) => {
          e.preventDefault();
      
          const formData = new FormData();
          formData.append('profile_photo', e.target.profile_photo.files[0]);
      
          axios
              .post(AppURL.Userprofile, formData, {
                  headers: {
                      'Content-Type': 'multipart/form-data',
                      Authorization: `Bearer ${localStorage.getItem('token')}`,
                  },
              })
              .then((response) => {
                  alert('Profile photo updated successfully!');
                  // Call updateProfileKey from props to remount the Profile component
                  this.props.updateProfileKey();
              })
              .catch((error) => {
                  console.error('Image upload failed:', error);
                  alert('Failed to upload image.');
              });
      };
      
      



     render() {

          const { uploadedImage, previewImage } = this.state;


          let name;
          let email;
          if (this.props.user) {
               name = this.props.user.name;
               email = this.props.user.email;
          }

          if (!localStorage.getItem('token')) {
               return <Navigate to="/login" />
          }


          return (
               <Fragment>
                    <div className="section-title text-center mb-55"><h2>User Profile Page</h2>
                    </div>

                    <Container>
                         <Row>

                              <Col lg={4} md={4} sm={12} >

                                   <Card className="mb-4" style={{ width: '18rem', margin: 'auto' }}>
                                        <Card.Img
                                             key={1} // Force re-render by adding a unique key
                                             variant="top"
                                             src={uploadedImage || DefaultImage}
                                             className="userprofile"
                                        />

                                        <ListGroup className="list-group-flush">

                                             <ListGroupItem> <Link className="text-link" to="/orderlist"> <p className="product-name-on-card"> Order List </p></Link> </ListGroupItem>

                                             <ListGroupItem> <Link className="text-link" to="/orderlist"> <p className="product-name-on-card"> Order List </p></Link> </ListGroupItem>

                                             <ListGroupItem> <Link className="text-link" to="/orderlist"> <p className="product-name-on-card"> Order List </p></Link> </ListGroupItem>
                                        </ListGroup>

                                   </Card>


                              </Col>


                              <Col lg={8} md={8} sm={12} >
                                   <ul className="list-group">
                                        <li className="list-group-item">Name :  {name} </li>
                                        <li className="list-group-item">Email :  {email} </li>
                                   </ul>


                                   {/* Image Upload Form */}
                                   <Form className="onboardForm" onSubmit={this.formSubmit}>
                                        <div className="mt-3">
                                             <label htmlFor="imageUpload" className="form-label">
                                                  Upload Profile Picture:
                                             </label>
                                             <input
                                                  type="file"
                                                  id="imageUpload"
                                                  name="profile_photo"
                                                  accept="image/*"
                                                  className="form-control"
                                                  onChange={this.handleImageUpload}
                                             />
                                        </div>

                                        {/* Preview Section */}
                                        {previewImage && (
                                             <Card className="mt-3" style={{ width: '18rem', margin: 'auto' }}>
                                                  <Card.Img variant="top" src={previewImage} />
                                             </Card>
                                        )}

                                        {/* Submit Button */}
                                        <Button type="submit" className="btn btn-block site-btn-login">
                                             Submit
                                        </Button>
                                   </Form>



                              </Col>

                         </Row>
                    </Container>


               </Fragment>
          )
     }
}

export default Profile
